import { Component, h, Prop } from '@stencil/core';

@Component({
	tag: 'x-circle-icon',
	shadow: false,
})
export class XCircleIcon {

	@Prop() svgStyle: any = {};
	@Prop() width: number = 24;
	@Prop() height: number = 24;

	render() {
		return (
			<svg width={this.width} height={this.height} viewBox="0 0 15 15" style={this.svgStyle}>
				<slot />

				<path d="M7.5 12.792c-2.922 0-5.292-2.371-5.292-5.292s2.371-5.292 5.292-5.292 5.292 2.371 5.292 5.292-2.37 5.292-5.292 5.292zM9.994 8.747l-1.247-1.248 1.247-1.248c0.083-0.082 0.131-0.193 0.131-0.31s-0.048-0.234-0.131-0.317l-0.62-0.62c-0.083-0.082-0.2-0.131-0.317-0.131s-0.227 0.048-0.31 0.131l-1.247 1.247-1.247-1.246c-0.083-0.082-0.193-0.13-0.31-0.13s-0.235 0.048-0.317 0.131l-0.62 0.619c-0.083 0.083-0.131 0.2-0.131 0.317 0 0.116 0.048 0.227 0.131 0.31l1.247 1.248-1.247 1.247c-0.083 0.082-0.131 0.193-0.131 0.31s0.048 0.234 0.131 0.317l0.62 0.62c0.083 0.082 0.2 0.131 0.317 0.131s0.227-0.048 0.31-0.131l1.247-1.247 1.247 1.247c0.083 0.082 0.193 0.131 0.31 0.131s0.235-0.048 0.317-0.131l0.62-0.62c0.083-0.083 0.131-0.2 0.131-0.317-0.001-0.116-0.049-0.227-0.132-0.31z" />
			</svg>
		);
	}

}
